import { useSyncExternalStore } from "react";

const TOUCH_PRIMARY_MEDIA_QUERY = "(hover: none) and (pointer: coarse)";

let touchPrimaryMediaQueryList: MediaQueryList | null = null;

function getTouchPrimaryMediaQueryList(): MediaQueryList | null {
  if (
    typeof window === "undefined" ||
    typeof window.matchMedia !== "function"
  ) {
    return null;
  }

  touchPrimaryMediaQueryList ??= window.matchMedia(TOUCH_PRIMARY_MEDIA_QUERY);
  return touchPrimaryMediaQueryList;
}

function subscribeToTouchPrimaryChanges(onStoreChange: () => void): () => void {
  const mediaQueryList = getTouchPrimaryMediaQueryList();

  if (!mediaQueryList) {
    return () => undefined;
  }

  if (typeof mediaQueryList.addEventListener === "function") {
    mediaQueryList.addEventListener("change", onStoreChange);
    return () => {
      mediaQueryList.removeEventListener("change", onStoreChange);
    };
  }

  mediaQueryList.addListener(onStoreChange);
  return () => {
    mediaQueryList.removeListener(onStoreChange);
  };
}

function getTouchPrimarySnapshot(): boolean {
  return getTouchPrimaryMediaQueryList()?.matches ?? false;
}

function getTouchPrimaryServerSnapshot(): boolean {
  return false;
}

export function useTouchPrimary(): boolean {
  return useSyncExternalStore(
    subscribeToTouchPrimaryChanges,
    getTouchPrimarySnapshot,
    getTouchPrimaryServerSnapshot,
  );
}
